import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSettingsGear1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"settings-gear-1, preferences"} maskId="square-filled-radius-0-stroke-1-IconSettingsGear1"><path fillRule="evenodd" clipRule="evenodd" d="M3 6.95657L12 1.92725L21 6.9566L21 17.0433L12 22.0726L3 17.0436V6.95657ZM8.25003 12C8.25003 9.92893 9.92896 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92896 15.75 8.25003 14.0711 8.25003 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSettingsGear1;
